<script setup>

import { ref } from "vue";

const props = defineProps({
    index: {
        type: Number,
        default: 0,
    },
    indexCount: {
        type: Number,
        default: 0,
    },
});

let isExpanded = ref(true);

function togglePanel() {
    isExpanded.value = !isExpanded.value;
}

function getButttonCls() {
    let classes = []
    if (props.index === 0) {
        classes.push('rounded-t-xl');
    }
    if (props.index !== props.indexCount - 1 || isExpanded.value) {
        classes.push('border-b-0')
    }
    if (isExpanded.value) {
        classes.push('bg-gray-100');
    } else {
        classes.push('hover:bg-gray-100');
    }

    return classes.join(' ');
}

function getContentCss() {
    let classes = []

    if (isExpanded.value && props.index !== props.indexCount - 1) {
        classes.push('border-b-0')
    }

    return classes.join(' ');
}
</script>
<template>
    <h2>
        <button type="button"
            class="flex items-center justify-between w-full p-5 font-medium text-gray-600 border border-gray-200"
            :class="getButttonCls()" @click="togglePanel">
            <span class="flex items-center">
                <slot name="title"></slot>
            </span>
            <svg class="w-6 h-6 shrink-0" :class="isExpanded ? 'rotate-180' : ''" fill="currentColor" viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clip-rule="evenodd"></path>
            </svg>
        </button>
    </h2>
    <div v-if="isExpanded">
        <div class="p-5 border border-gray-200" :class="getContentCss()">
            <slot name="content" />
        </div>
    </div>
</template>
